import { useState, useEffect } from 'react';
import { PlusIcon, PencilIcon, TrashIcon } from '@heroicons/react/24/outline';
import { updateDmInstructions } from '../../../api/social';
import {
  PlatformType,
  SocialProvider,
  useSocial,
} from '../../../context/socialProvider';
import { Save } from './Save';

interface DmResponseSettingsProps {
  selectedSocial: any;
}

const DmResponseSettings = ({ selectedSocial }: DmResponseSettingsProps) => {
  const { currentSocial, refreshSocialInfo } = useSocial();

  // DM Instructions State
  const [initialDmInstructions, setInitialDmInstructions] = useState('');
  const [dmInstructions, setDmInstructions] = useState('');
  const [isSavingDmInstructions, setIsSavingDmInstructions] = useState(false);

  // Initialize state from selectedSocial
  useEffect(() => {
    if (selectedSocial) {
      setDmInstructions(selectedSocial.dmDescription || '');
      setInitialDmInstructions(selectedSocial.dmDescription || '');
    }
  }, [selectedSocial]);

  // DM Instructions Functions
  const handleDmInstructionsSave = async () => {
    if (!selectedSocial) return;
    setIsSavingDmInstructions(true);
    try {
      await updateDmInstructions(selectedSocial.id, dmInstructions);
      if (currentSocial?.id === selectedSocial.id) {
        await refreshSocialInfo();
      }
      setInitialDmInstructions(dmInstructions);
    } catch (error) {
      console.error('Error saving DM instructions:', error);
    } finally {
      setIsSavingDmInstructions(false);
    }
  };

  return (
    <div className="space-y-6">
      {/* DM Response Instructions */}
      <div className="settings-container bio bg-grey rounded-xl p-6 shadow-lg border border-gray-700">
        <h2 className="font-semibold text-xl text-white mb-4">
          DM Response Instructions
        </h2>
        <p className="text-sm text-gray-300 mb-4">
          Provide specific instructions for how the AI should handle and respond
          to direct messages
        </p>

        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-200 mb-2">
            Response Instructions
          </label>
          <textarea
            className="bg-black border border-gray-600 rounded p-3 w-full text-sm text-white focus:outline-none focus:ring-2 focus:ring-violet h-80"
            placeholder="Provide specific instructions for how the AI should handle direct messages..."
            value={dmInstructions}
            onChange={(e) => setDmInstructions(e.target.value)}
            disabled={currentSocial?.provider != PlatformType.INSTAGRAM}
          />
          <Save
            initialValue={initialDmInstructions}
            currentValue={dmInstructions}
            isLoading={isSavingDmInstructions}
            onClick={handleDmInstructionsSave}
          />
        </div>
      </div>
    </div>
  );
};

export default DmResponseSettings;
